import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const SsoCore = (props) => {
  const { config } = useSelector((state) => state.global);
  const { userHelper, message } = config;

  const location = useLocation();

  useEffect(() => {
    doSSOLogin();
  }, []);

  const doSSOLogin = async () => {
    const query = new URLSearchParams(location?.search);
    const token = query.get("token");
    const redirectUrl = query.get("redirect");

    if (!token) {
      message.add({
        type: "error",
        message:
          "Não foi possível realizar o SSO! Token de acesso não encontrado.",
        persist: true,
      });
      window.location.href = "/login";
      return;
    }

    let result = await userHelper.userLoginWithToken(token);

    if (result?.success) {
      if (redirectUrl) {
        window.location.href = redirectUrl;
      } else {
        window.location.href = "/";
      }
      return;
    } else {
      switch (result?.error?.code) {
        case "auth/user-disabled":
          message.add({
            type: "error",
            message: "Usuário desabilitado!",
            persist: true,
          });
          break;
        default:
          message.add({
            type: "error",
            message: "Ocorreu um erro inesperado!",
            persist: true,
          });
      }

      window.location.href = "/login";
      return;
    }
  };

  return <></>;
};

export default SsoCore;
